exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-snack-bar .MuiSnackbar-anchorOriginBottomCenter{left:20px;-webkit-transform:none;-ms-transform:none;transform:none}.common-snack-bar .MuiSnackbarContent-message{width:283px}.common-snack-bar .MuiIconButton-label{font-size:16px}.common-snack-bar .MuiSnackbarContent-action{padding-left:0px}.mobile-layout .common-snack-bar .MuiSnackbar-root{width:90%;margin:0px auto}.mobile-layout .common-snack-bar .MuiSnackbar-anchorOriginBottomCenter{left:6px}.mobile-layout .common-snack-bar .MuiSnackbar-root{margin:0px auto}.mobile-layout .common-snack-bar .MuiSnackbarContent-message{max-width:80%}", ""]);

// exports
